export default (connection: string) => (
    `event:mercure-connection:${connection}:lost`
);

export type MercureConnectionLostEventParameters = {
    connectionName: string,
};
